import { z } from 'zod';

// Line item for requisition creation
export const createRequisitionLineSchema = z.object({
  itemId: z.string(),
  itemName: z.string(),
  sku: z.string(),
  quantity: z.number().min(0.01),
  unit: z.string(),
  notes: z.string().optional(),
  // Source tracking for exploded items
  sourceType: z.enum(['manual', 'recipe', 'menu']).optional(),
  sourceId: z.string().optional(),
  sourceName: z.string().optional(),
});

export type CreateRequisitionLine = z.infer<typeof createRequisitionLineSchema>;

// Request payload for creating a requisition
export const createRequisitionRequestSchema = z.object({
  venueId: z.string().min(1, 'Venue is required'),
  venueName: z.string(),
  neededBy: z.string().min(1, 'Required date is required'),
  priority: z.enum(['low', 'normal', 'high', 'urgent']).default('normal'),
  notes: z.string().optional(),
  items: z.array(createRequisitionLineSchema).min(1, 'At least one item is required'),
});

export type CreateRequisitionRequest = z.infer<typeof createRequisitionRequestSchema>;

// Response from create requisition API
export const createRequisitionResponseSchema = z.object({
  requisitionId: z.string(),
  status: z.string(),
  message: z.string(),
});

export type CreateRequisitionResponse = z.infer<typeof createRequisitionResponseSchema>;

// Recipe selection for explosion
export interface RecipeSelection {
  recipeId: string;
  recipeName: string;
  portions: number;
}

// Menu selection for explosion
export interface MenuSelection {
  menuId: string;
  menuName: string;
  paxCount: number;
}

// Aggregated ingredient from explosion
export interface IngredientSource {
  type: 'recipe' | 'menu';
  id: string;
  name: string;
  quantity: number;
}

export interface AggregatedIngredient {
  itemId: string;
  itemName: string;
  sku: string;
  unit: string;
  totalQuantity: number;
  sources: IngredientSource[];
}
